module.exports = __webpack_public_path__ + "static/media/bg3.54a9c882.jpg";